<form [formGroup]="formGroup" class="campo-busqueda">
    <img src="./assets/componentes-compartidos/buscar.svg"/>
    <input formControlName="palabrasClave" type="text" placeholder="Buscar">
    <img (click)="handleLimpiar()" src="./assets/componentes-compartidos/cerrar.svg"/>
</form>